import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {ICategory} from '../../interfaces/ICategory';

@Component({
  selector: 'search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        height: '*',
        opacity: 1
      })),
      state('out', style({
        height: '0',
        opacity: 0
      })),
      transition('in <=> out', animate('300ms ease-in-out'))
    ])
  ]
})

export class SearchFiltersComponent {

  @Output() onSearch = new EventEmitter();
  @Input() accountType: string;
  @Input() addresses = [];
  @Input() categories: Array<ICategory> = [];
  @Input() subcategories = [];
  @Input() loading = true;
  @Input() searchType;
  @Input() currentLocation: string;
  @Input() set params(params) {
    this.searchParams = params;
    if (this.searchType) { this.onChangeSearchType(); }
  }

  searchParams;
  locationLabel = 'Seus endereços';
  showCategoryFilter = false;
  showLocationFilter = false;

  onSelectCategory(category): void {
    for (const subcategory of category.subcategories) {
      subcategory.checked = category.checked;
    }

    this.updateCategoriesSearchParam();
  }

  updateCategoriesSearchParam() {
    const selectedCategories = [];
    for (const category of this.categories) {
      if (category.checked) {
        const selectedCategory = {
          id: category.id,
          slug: category.slug,
          subcategories: this.getSelectedSubcategories(category.subcategories)
        };
        selectedCategories.push(selectedCategory);
      }
    }

    this.searchParams.categories = selectedCategories;
  }

  getSelectedSubcategories(subcategories) {
    const selectedSubcategories = [];
    for (const subcategory of subcategories) {
      if (subcategory.checked) {
        selectedSubcategories.push({id: subcategory.id, slug: subcategory.slug});
      }
    }

    return selectedSubcategories;
  }

  toggleCategory(category: any) {
    category.showSubcategories = !category.showSubcategories;
  }

  onSelectLocation(location) {
    this.searchParams.location = location;
    this.searchType.nearSearchLabel = this.getNearSearchLabel();
    this.search();
  }

  onChangeSearchType() {
    this.searchType.nearSearchLabel = this.getNearSearchLabel();
  }

  getSearchLabel() {
    return this.accountType === 'establishment'
      ? 'Pesquisar'
      : 'Busca';
  }

  getPlaceholderForSearch() {
    return this.accountType === 'establishment'
      ? 'nome da empresa'
      : 'nome, serviço';
  }

  search() {
    this.showLocationFilter = false;
    this.showCategoryFilter = false;
    this.onSearch.emit();
  }

  getSelectedLocation = () => {
    return this.addresses.find(el => {
      const { lat, lng } = el.location;
      const location = this.searchParams.location.split(',').map(parseFloat);
      return (lat === location[0] && lng === location[1]);
    });
  }

  getNearSearchLabel() {
    let nearSearchLabel;
    const location = this.getSelectedLocation();

    if (this.searchType && this.searchType.near) {
      nearSearchLabel = location ? location.nameUnit : 'Minha localização';
    } else {
      nearSearchLabel = 'Brasil';
    }

    this.searchType.nearSearchLabel = nearSearchLabel;

    return nearSearchLabel;
  }

  isAddressChecked(address) {
    return `${address.location.lat},${address.location.lng}` === this.searchParams.location;
  }
}
